type PrincipalLoadingProps = {
  className?: string
}

function joinClasses(...classes: Array<string | undefined>) {
  return classes.filter(Boolean).join(' ')
}

export function PrincipalLoading({ className }: PrincipalLoadingProps) {
  return (
    <div
      role="status"
      aria-label="Loading"
      data-testid="principal-loading"
      className={joinClasses('lds-ellipsis', className)}
    >
      <div />
      <div />
      <div />
      <div />
    </div>
  )
}

export function PageLoadingCenter({
  className,
  'data-testid': dataTestId
}: {
  className?: string
  'data-testid'?: string
}) {
  return (
    <div
      className={joinClasses(
        'flex size-full min-h-0 flex-1 items-center justify-center',
        className
      )}
      data-testid={dataTestId}
    >
      <PrincipalLoading />
    </div>
  )
}

export function AppLoadingScreen() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#f4f6f9]">
      <PrincipalLoading />
    </div>
  )
}
